import { useEffect, useState, useContext } from "react";
import "../css/App.css";
import Constantes from "../../constantes.js";
import { AuthContext } from "../../contexto/AuthContext";

function Header() {
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  const [admin, setAdmin] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      fetch(Constantes.RUTA_API + "/usuarios/datosUsuario", {
        method: "GET",
        credentials: "include",
      })
        .then((res) => res.json())
        .then((data) => {
          if (
            !data.error &&
            data.datosUsuario?.userData?.tipo_usuario === "admin"
          ) {
            setAdmin(true);
          } else {
            setAdmin(false);
          }
        })
        .catch((err) => {
          console.error("Error al verificar si el usuario es admin:", err);
          setAdmin(false);
        });
    } else {
      setAdmin(false);
    }
  }, [isAuthenticated]);

  if (isLoading) {
    // Mostrar header de no-autenticado mientras se valida
    return (
      <>
        <nav className="navbar navbar-expand-sm header">
          <div className="container-fluid">
            <ul className="navbar-nav">
              <li className="nav-item">
                <a className="nav-link a contorno" href="/">
                  <i className="bi bi-house-door-fill mx-2"></i>
                  <span className="nav-text">Yourny</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link a contorno" href="/Registro">
                  <i className="bi bi-person-plus-fill mx-2"></i>
                  <span className="nav-text">Registro</span>
                </a>
              </li>
            </ul>
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a className="nav-link a contorno" href="/login">
                  <i className="bi bi-box-arrow-in-right mx-2"></i>
                  <span className="nav-text">Login</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </>
    );
  }

  if (isAuthenticated) {
    return (
      <>
        <nav className="navbar navbar-expand-sm header">
          <div className="container-fluid">
            <ul className="navbar-nav">
              <li className="nav-item ms-auto">
                <a className="nav-link a contorno" href="/">
                  <i className="bi bi-house-door-fill mx-2"></i>
                  <span className="nav-text">Yourny</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link a contorno" href="/GyC">
                  <i className="bi bi-people-fill mx-2"></i>
                  <span className="nav-text">Grupos y comunidades</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link a contorno" href="/Mensajes">
                  <i className="bi bi-chat-fill mx-2"></i>
                  <span className="nav-text">Mensajes</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link a contorno" href="/Inventario">
                  <i className="bi bi-patch-plus-fill mx-2"></i>
                  <span className="nav-text">Inventario de insignias</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link a contorno" href="/SubirPublicacion">
                  <i className="bi bi-cloud-upload-fill mx-2"></i>
                  <span className="nav-text">Subir publicación</span>
                </a>
              </li>
            </ul>

            <ul className="navbar-nav ms-auto">
              {admin === true && (
                <li className="nav-item">
                  <a className="nav-link a contorno" href="/admin">
                    <i className="bi bi-gear-fill mx-2"></i>
                    <span className="nav-text">Administración</span>
                  </a>
                </li>
              )}
              <li className="nav-item">
                <a className="nav-link a contorno" href="/ConfiguracionCuenta">
                  <i className="bi bi-gear mx-2"></i>
                  <span className="nav-text">Configuración de cuenta ⚙</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link a contorno" href="/logout">
                  <i className="bi bi-box-arrow-right mx-2"></i>
                  <span className="nav-text">Logout</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </>
    );
  } else {
    return (
      <>
        <nav className="navbar navbar-expand-sm header">
          <div className="container-fluid">
            <ul className="navbar-nav">
              <li className="nav-item">
                <a className="nav-link a contorno" href="/">
                  <i className="bi bi-house-door-fill mx-2"></i>
                  <span className="nav-text">Yourny</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link a contorno" href="/Registro">
                  <i className="bi bi-person-plus mx-2"></i>
                  <span className="nav-text">Registro</span>
                </a>
              </li>
            </ul>
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a className="nav-link a contorno" href="/login">
                  <i className="bi bi-box-arrow-in-right mx-2"></i>
                  <span className="nav-text">Login</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </>
    );
  }
}

export default Header;
